/*
 * @Description:封装axios
 * @Author: 王振
 * @Date: 2021-06-02 13:22:54
 * @LastEditors: 王振
 * @LastEditTime: 2021-07-29 11:04:29
 */

//导入axios
import axios from "axios";
// vant的toast提示框组件
import { MessageBox, Message } from "element-ui";
import { getToken } from "@/utils/auth";

//1. 创建新的axios实例
const instance = axios.create({
  // 公共接口
  baseURL: "https://56lsh.com/tms",
  // 超时时间 单位是ms，这里设置了10s的超时时间
  timeout: 10000,
});

//2. 配置请求头，全局的 axios 默认值
instance.defaults.headers.post["Content-Type"] = "application/json;charset=UTF-8"; // 流程组件 content-type

//3.添加一个请求拦截器
instance.interceptors.request.use(
  (config) => {
    //发请求前做的一些处理，数据转化，配置请求头，设置token,设置loading等
    //设置token
    if (getToken()) {
      config.headers["X-Token"] = getToken();
    }
    //数据转换,判断数据格式为formdata还是json格式
    //json格式
    config.data = JSON.stringify(config.data);
    return config;
  },
  (error) => {
    //出现请求错误，清除toast
    // Toast.clear();
    // Toast("请求错误，请稍后重试");
    console.info("error: ");
    console.info(error);
    return Promise.reject(error);
  }
);

//4. 添加一个响应拦截器
instance.interceptors.response.use(
  (response) => {
    // 成功请求到数据，关闭等待提示
    const res = response.data;
    //判断code状态，是否成功获取数据
    if (res.code != 0) {
      Message({
        message: res.msg || "Error",
        type: "error",
        duration: 5 * 1000,
      });
      return Promise.reject(new Error(res.msg || "Error"));
    } else {
      return res;
    }
  },
  (error) => {
    //响应失败，关闭等待提示
    // 超时处理
    if (JSON.stringify(error).includes("Network Error")) {
      Message({
        message: "网络超时",
        type: "error",
        duration: 5 * 1000,
      });
    } else {
      Message({
        message: error.msg,
        type: "error",
        duration: 5 * 1000,
      });
    }
    console.log(error);
    return Promise.reject(error);
  }
);

//5. 导出文件
export default instance;



// WEBPACK FOOTER //
// ./src/utils/request.js